import * as React from "react";

import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  TextField,
  Typography,
} from "@mui/material";
import { Form, useLoaderData, useNavigate, useParams } from "react-router-dom";
import { Result } from "../../types/Result";
import { ExamTypeCategory } from "./type";

export default function ExamTypeCategoryForm() {
  const params = useParams();
  const navigate = useNavigate();
  const data = useLoaderData() as Result<ExamTypeCategory>;

  const [values, setValues] = React.useState<ExamTypeCategory>(data.data!);

  const handleCancel = () => {
    navigate(-1); // Go back to previous page
  };

  return (
    <>
      <Card>
        <CardHeader
          title={
            params.code
              ? "Sınav Tipi Kategori Düzenle"
              : "Yeni Sınav Tipi Kategori"
          }
        />

        <CardContent>
          <Form method="post">
            <input
              type="hidden"
              name="examTypeCode"
              value={values.examTypeCode}
            />
            <input
              type="hidden"
              name="categoryCode"
              value={values.categoryCode}
            />

            {/* Name field (note: in your interface this is a number) */}
            <TextField
              fullWidth
              required
              id="categoryCode"
              name="categoryCode"
              label="İsim"
              type="string"
              defaultValue={values.categoryCode}
              margin="normal"
              variant="outlined"
              disabled={params.categoryCode !== "new"} // Disable if editing an existing exam type
            />

            {/* Explanation field */}
            <TextField
              fullWidth
              id="categoryName"
              name="categoryName"
              label="Ad"
              defaultValue={values.categoryName}
              margin="normal"
              variant="outlined"
              multiline
              rows={4}
            />

            {/* Error messages */}
            {data?.errors && data.errors.length > 0 && (
              <Box sx={{ mt: 2, color: "error.main" }}>
                {data.errors.map((error, index) => (
                  <Typography key={index} color="error">
                    {error}
                  </Typography>
                ))}
              </Box>
            )}

            {/* Action buttons */}
            <Box
              sx={{ mt: 3, display: "flex", justifyContent: "space-between" }}
            >
              <Button variant="outlined" onClick={handleCancel}>
                İptal
              </Button>
              <Button type="submit" variant="contained" color="primary">
                Kaydet
              </Button>
            </Box>
          </Form>
        </CardContent>
      </Card>
    </>
  );
}
